import React, { useState } from 'react';

// Simple accessible accordion for on-page FAQ content.
// items: [{ q: string, a: string }]
const FAQAccordion = ({ items, title }) => {
  const [openIndex, setOpenIndex] = useState(0);

  if (!items || items.length === 0) return null;

  return (
    <section className="faq-accordion">
      {title && <h2 className="section-title">{title}</h2>}
      <div className="faq-accordion__list">
        {items.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className={`faq-accordion__item ${isOpen ? 'faq-accordion__item--open' : ''}`}>
              <button
                className="faq-accordion__question"
                onClick={() => setOpenIndex(isOpen ? -1 : i)}
                aria-expanded={isOpen}
              >
                <span>{item.q}</span>
                <span className="faq-accordion__icon">{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen && <p className="faq-accordion__answer">{item.a}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FAQAccordion;
